import React from 'react';
import './Proceso.css';

const Proceso = () => {
    return (
        <section className="proceso" id="proceso">
            <div className="container">
                <div className="proceso-header">
                    <div>
                        {/* Agregamos 'in' a las clases 'rv' para asegurar que sean visibles */}
                        <div className="eyebrow rv in">Nuestro proceso</div>
                        <h2 className="s-title rv in d1">Cuatro fases.<br />Un camino completo.</h2>
                    </div>
                    <p className="s-sub rv in d2" style={{ textAlign: 'right' }}>
                        Cada empresa tiene su punto de partida. Nosotros lo identificamos y avanzamos juntos.
                    </p>
                </div>

                <div className="proceso-grid">
                    {/* Fase 1 */}
                    <div className="fase-card rv in">
                        <div className="fase-node">01</div>
                        <div className="fase-icon">
                            <svg viewBox="0 0 26 26" fill="none" stroke="#1022C8" strokeWidth="1.6" strokeLinecap="round">
                                <circle cx="11" cy="11" r="7"/>
                                <path d="M16 16l5 5M8 11h6M11 8v6"/>
                            </svg>
                        </div>
                        <div className="fase-name">Auditoría</div>
                        <div className="fase-desc">
                            Mapeamos tus procesos actuales, identificamos ineficiencias y establecemos KPIs base. Sin supuestos, solo datos.
                        </div>
                        <div className="fase-tags">
                            <span className="fase-tag">Mapeo</span>
                            <span className="fase-tag">Diagnóstico</span>
                            <span className="fase-tag">KPIs</span>
                        </div>
                    </div>

                    {/* Fase 2 */}
                    <div className="fase-card rv in d1">
                        <div className="fase-node">02</div>
                        <div className="fase-icon">
                            <svg viewBox="0 0 26 26" fill="none" stroke="#1022C8" strokeWidth="1.6" strokeLinecap="round">
                                <path d="M4 20l4-4 4 4 4-8 4 4"/>
                                <rect x="3" y="3" width="20" height="14" rx="2"/>
                            </svg>
                        </div>
                        <div className="fase-name">Consultoría</div>
                        <div className="fase-desc">
                            Diseñamos una hoja de ruta personalizada con soluciones de IA adaptadas a tu operación y presupuesto.
                        </div>
                        <div className="fase-tags">
                            <span className="fase-tag">Hoja de ruta</span>
                            <span className="fase-tag">Estrategia</span>
                            <span className="fase-tag">Quick wins</span>
                        </div>
                    </div>

                    {/* Fase 3 */}
                    <div className="fase-card rv in d2">
                        <div className="fase-node">03</div>
                        <div className="fase-icon">
                            <svg viewBox="0 0 26 26" fill="none" stroke="#1022C8" strokeWidth="1.6" strokeLinecap="round">
                                <polyline points="6,12 10,16 20,8"/>
                                <rect x="3" y="3" width="20" height="20" rx="3"/>
                            </svg>
                        </div>
                        <div className="fase-name">Implementación</div>
                        <div className="fase-desc">
                            Desplegamos soluciones de forma iterativa, minimizando interrupciones en tu operación diaria.
                        </div>
                        <div className="fase-tags">
                            <span className="fase-tag">Integración</span>
                            <span className="fase-tag">Sin pausas</span>
                            <span className="fase-tag">Iterativo</span>
                        </div>
                    </div>

                    {/* Fase 4 */}
                    <div className="fase-card rv in d3">
                        <div className="fase-node">04</div>
                        <div className="fase-icon">
                            <svg viewBox="0 0 26 26" fill="none" stroke="#1022C8" strokeWidth="1.6" strokeLinecap="round">
                                <path d="M4 7h18M4 13h12M4 19h8"/>
                                <circle cx="21" cy="18" r="4"/>
                                <path d="M21 16v2l1.5 1.5"/>
                            </svg>
                        </div>
                        <div className="fase-name">Capacitación</div>
                        <div className="fase-desc">
                            Habilitamos a tu equipo para operar y evolucionar las soluciones de forma autónoma. El conocimiento queda en tu empresa.
                        </div>
                        <div className="fase-tags">
                            <span className="fase-tag">Workshops</span>
                            <span className="fase-tag">Documentación</span>
                            <span className="fase-tag">Autonomía</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Proceso;